/** @format */

const loaderStyle = {
    adescomLoader: {
        color: 'white',
        position: 'fixed',
        top: '45vh',
        left: '50vw',
        zIndex: 1000000001,
    },
    tinyInlineLoader: {
        maxWidth: '20px',
        marginTop: '5px',
        maxHeight: '20px',
    },
};

export default loaderStyle;
